<template>
  <div class="rule-container">
    <div class="rule-wrapper" @click.stop>
      <div class="rule-title">活动规则</div>
      <div class="rule-list">
        <div class="rule-item" v-for="(item, index) in rule" :key="index">
          <div class="item-num">{{ (index + 1) | fillZero }}</div>
          <div class="item-text" v-html="item"></div>
        </div>
      </div>
      <div class="btn" @click="bindClose">我知道了</div>
      <div class="close iconfont icon-cha" @click="bindClose"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      rule: [
        `每推荐一位好友购买正价减脂营后<span style="font-weight:bold">双方均可获得100元返现</span>，上不封顶，需联系自己的陪伴官获取`,
        `领取现金后不可以产生退款，若产生退款需扣除双方的返现总金额`,
        `本活动最终解释权归betterWE所有`
      ]
    }
  },
  filters: {
    fillZero(index) {
      return index <= 9 && index > 0 ? '0' + index : index
    }
  },
  created() {},
  methods: {
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.rule-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .rule-wrapper {
    position: relative;
    width: 280px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px 16px 20px;
    .rule-title {
      text-align: center;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.8);
      font-weight: bold;
      margin-bottom: 16px;
    }
    .rule-list {
      margin-bottom: 20px;
      .rule-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
        .item-num {
          white-space: nowrap;
          font-size: 14px;
          font-weight: bold;
          font-family: DIN;
          margin-right: 6px;
        }
        .item-text {
          font-size: 12px;
          line-height: 20px;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
    .btn {
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: linear-gradient(270deg, #ff2774 0%, #ff366d 100%);
      border-radius: 20px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
    }
    .close {
      position: absolute;
      left: 50%;
      bottom: -60px;
      transform: translate(-50%, -50%);
      width: 24px;
      height: 24px;
      box-sizing: border-box;
      border: 1px solid #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }
  }
}
</style>
